import { Link } from '@heroui/link';
import { Button } from '@heroui/button';
import { MdArrowBackIos, MdArrowForwardIos } from 'react-icons/md';

import { Song } from '@/core/db.ts';
import { useSongs } from '@/hooks/useSongbook.ts';
import { songName } from '@/core/song.ts';

interface SongNavigationProps {
  song: Song;
}

function SongNavigation({ song }: SongNavigationProps) {
  const { data: songs = [], isLoading } = useSongs(song.songbookId);

  const prev = songs[song.order - 2];
  const next = songs[song.order];

  if (isLoading) {
    return (
      <div className="my-4">
        <div className="h-10" />
      </div>
    );
  }

  if (!prev && !next) {
    return null;
  }

  return (
    <div className="my-4 flex justify-between">
      {prev ? (
        <Button
          as={Link}
          href={`/songbook/${prev.songbookId}/song/${prev.id}`}
          startContent={<MdArrowBackIos />}
          variant="light"
        >
          {songName(prev)}
        </Button>
      ) : (
        <div />
      )}
      {next && (
        <Button
          as={Link}
          endContent={<MdArrowForwardIos />}
          href={`/songbook/${next.songbookId}/song/${next.id}`}
          variant="light"
        >
          {songName(next)}
        </Button>
      )}
    </div>
  );
}

export default SongNavigation;
